import * as React from 'react';
import { Link } from 'react-router-dom';
import { imageUrl } from '../../../config';
import Image from '../../../components/Image';
import { isExternalLink } from '../../../helpers/isExternalLink';
import { addWebpSuffixIfSupported } from '../../../utils/webP';

interface ISlideProps {
  id: number;
  img: string;
  title?: string;
  subtitle?: string;
  description?: string;
  productImage?: string;
  link?: string | null;
}

// 18. 12. 2023:
// img.slide__img má mít width={735} height={280}
// .slide__productImage má mít width={240} height={240}
// Ale bannery neřešíme, protože resizer nezaručí potřebnou kvalitu

const Slide = (props: ISlideProps) => {
  const { img, title, subtitle, description, productImage, link } = props;
  const correctLink = link && link !== '' && link !== '/' ? link : null;

  return (
    <div className="slide" style={img ? { backgroundImage: `url(${addWebpSuffixIfSupported(`${imageUrl}${img}`)})` } : {}}>
      {img && <img className="slide__img" src={addWebpSuffixIfSupported(imageUrl + img)} alt={title} />}
      <div className="slide__content d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div>
              {title && <div className="slide__title">{title}</div>}
              {subtitle && <div className="slide__subtitle">{subtitle}</div>}
              {description && <div className="slide__description">{description}</div>}

              {correctLink && !isExternalLink(correctLink) && (
                <Link to={correctLink} className="slide__more">
                  Learn More
                </Link>
              )}

              {correctLink && isExternalLink(correctLink) && (
                <a href={correctLink} className="slide__more">
                  Learn More
                </a>
              )}
            </div>
            {productImage && <Image image={productImage} className="slide__productImage" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Carousel/Slide/Slide.tsx